import $ from 'jquery';

$('.ucg-list-3-block .tabs .tab').on('click', function() {
  let index = $(this).data('index')
  if ($(window).width() <= 960) {
    if ($(this).hasClass('active')) {
      $(this).siblings().slideDown()
    } else {
      $(this).addClass('active').siblings().removeClass('active').slideUp()
    }
  } else {
    $(this).addClass('active').siblings().removeClass('active')
  }
  $(this).parent().next().find('.tab-content-'+index).addClass('active').siblings().removeClass('active')
});

$(window).on('load, resize', function() {
  let tab = $('.ucg-list-3-block .tabs .tab')
  tab.each(function() {
    if ($(window).width() <= 960) {
      if ($(this).hasClass('active')) {
        $(this).slideDown()
      } else {
        $(this).slideUp()
      }
    } else {
      $(this).slideDown()
    }
  })
})